import common from '@/common';

class AudioPreloader {
  private preloadPromise: Promise<void> | null = null;
  private loaded = 0;
  private total = 0;
  private concurrency = 3;

  preloadAll(): Promise<void> {
    if (this.preloadPromise) {
      return this.preloadPromise;
    }

    this.preloadPromise = new Promise((resolve) => {
      const voices = common.config.voice;
      const paths = new Set<string>();
      
      voices.forEach((voice) => {
        paths.add(voice.path);
        if (voice.tips) paths.add(voice.tips);
      });

      const pathList = Array.from(paths);
      this.total = pathList.length;
      
      if (this.total === 0) {
        resolve();
        return;
      }

      let index = 0;
      const next = () => {
        if (index >= pathList.length) {
          if (this.loaded === this.total) {
            this.preloadPromise = Promise.resolve(); // 确保完成后 promise 是 resolved 状态
            resolve();
          }
          return;
        }

        const path = pathList[index++];
        fetch(path)
          .then(response => response.blob())
          .catch(err => {
            console.warn(`Failed to preload audio: ${path}`, err);
          })
          .finally(() => {
            this.loaded++;
            next();
          });
      };

      for (let i = 0; i < Math.min(this.concurrency, pathList.length); i++) {
        next();
      }
    });

    return this.preloadPromise;
  }

  getProgress() {
    return { loaded: this.loaded, total: this.total };
  }

  isComplete() {
    return this.loaded === this.total && this.total > 0;
  }
}

export default new AudioPreloader();
